import {ReactNode} from 'react';
import classNames from 'classnames';

export const TableContainer = ({children, overflowAuto = true}: {children?: ReactNode; overflowAuto?: boolean}) => (
  <div
    className={classNames('flex h-full w-full grow flex-col justify-between', {
      'overflow-auto': overflowAuto
    })}
  >
    {children}
  </div>
);
